import axios from "axios";
const { API_BACKEND_HOST } = process.env;
const responseFormat = { error: "", data: null };

export const sendEmailInviteSlot = async (request) => {
  const languageId = localStorage.getItem("i18nextLng");
  try {
    const response = await axios.post(
      `${API_BACKEND_HOST}${languageId}/v1/Committee/meets/agenda/confirm-slot`,
      request,
    );
    responseFormat.data = response;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error =
      response.data.errors || "Erro ao tentar enviar o email";
    return responseFormat;
  }
};
export const getTemplateEmail = async (templateType) => {
  const languageId = localStorage.getItem("i18nextLng");
  let teste = 'Slot Confirmation'
  try {
    const response = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/Committee/template?templetaType=${teste}`,
    );
    responseFormat.data = response;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error =
      response.data.errors || "Erro ao tentar enviar o email";
    return responseFormat;
  }
};

export const sendEmailBatchConfirmSlots = async (request) => {
  const languageId = localStorage.getItem("i18nextLng");
  try {
    const response = await axios.post(
      `${API_BACKEND_HOST}${languageId}/v1/Committee/meets/agenda/confirm-slots-batch`,
      request,
    );
    responseFormat.data = response;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error =
      response.data.errors || "Erro ao confirmar os slots em lote";
    return responseFormat;
  }
};

export const getMeetingTemplateslot = async (request) => {
  const languageId = localStorage.getItem("i18nextLng");
  try {
    const { data } = await axios({
      method: "POST",
      url: `${API_BACKEND_HOST}${languageId}/v1/Committee/template-slot`,
      data: request,
    });

    responseFormat.data = data;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ e }) {
    responseFormat.error = "async";
    return responseFormat;
  }
};

